import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import type { SegmentedOptionsGroupOnValueChangeHandler } from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { setTourPriceMode } from 'actions/tour/TourV2Actions'
import { getTourPriceMode } from 'selectors/TourV2/toursSelectors'

function TourDealPriceToggle() {
  const intl = useIntl()
  const tourPriceMode = useAppSelector(getTourPriceMode)
  const dispatch = useAppDispatch()
  const handleChange = useCallback<SegmentedOptionsGroupOnValueChangeHandler<'total' | 'perDay'>>((newValue) => {
    dispatch(setTourPriceMode(newValue))
  }, [dispatch])

  return (<form>
    <SegmentedOptionsGroup
      inputsName="tourPriceMode"
      onValueChange={handleChange}
    >
      <SegmentedOption
        checked={tourPriceMode === 'total'}
        value="total"
        title={intl.formatMessage(
          {
            id: 'sNEY6H1Elic4gg9OBrte',
            defaultMessage: 'Price: Total',
            description: 'Toggle option to display the total price for a tour',
          },
        )}
      />
      <SegmentedOption
        checked={tourPriceMode === 'perDay'}
        value="perDay"
        title={intl.formatMessage(
          {
            id: 'rW2kedyKqEEUnFx62iio',
            defaultMessage: 'Price: Per day',
            description: 'Toggle option to display the per-day price for a tour',
          },
        )}
      />
    </SegmentedOptionsGroup>
  </form>)
}

export default TourDealPriceToggle
